import { useMemo } from "react";

import { Stack } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import StackStateBadge from "components/StackStateBadge";
import { StackSuggestions } from "constants/stack";

import useCellFilterAction from "../useCellFilterAction";
import useGoToRunAction from "../useGoToRunAction";

const StacksTableStateCell = ({ item: stack, ...cellProps }: TableSimpleCellProps<Stack>) => {
  const filterAction = useCellFilterAction({
    filterName: StackSuggestions.State,
    filterValue: stack.state,
  });

  const runUrl = stack.stateSetBy ? `/stack/${stack.id}/run/${stack.stateSetBy}` : undefined;
  const goToRunAction = useGoToRunAction(runUrl);

  const actions = useMemo(() => {
    if (goToRunAction) {
      return [filterAction, goToRunAction];
    }

    return [filterAction];
  }, [filterAction, goToRunAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <StackStateBadge state={stack.state} />
    </TableSimpleCell>
  );
};

export default StacksTableStateCell;
